'use client';

import { useSettings } from '@/hooks/useSettings';

interface settingsType {
  type: string | null;
  value: string | null;
}

export default function ShippingDelivery() {
  const { generalSettings } = useSettings();

  const shippingCost = generalSettings?.filter(
    (item: settingsType) => item?.type === 'default_shipping_cost'
  );
  const minShippingAmount = generalSettings?.filter(
    (item: settingsType) => item?.type === 'min_amount_free_shipping'
  );

  return (
    <>
      <main className="main padding-bottom">
        <div className="page-header">
          <div className="container">
            <div
              style={{ background: '#f4f4f4' }}
              className="d-flex flex-column align-items-center text-center py-3 py-lg-5 px-2 rounded-3"
            >
              <h2 className="fw-semibold"> Shipping - Delivery</h2>
              <p>Fast, reliable shipping to your doorstep</p>
            </div>
          </div>
        </div>
        <div className="container pt-3 pt-lg-5">
          <div className="row g-4">
            <div className="col-12">
              <div className="row g-4">
                <div className="col-12">
                  <h4 className="fw-semibold">
                    How does the delivery process work?
                  </h4>
                  <ol>
                    <li>
                      Once our system processes your order, your products are
                      inspected thoroughly to ensure they are in a perfect
                      condition.
                    </li>
                    <li>
                      After they pass through the final round of quality check,
                      they are packed and handed over to our trusted delivery
                      partner.
                    </li>
                    <li>
                      Our delivery partners then bring the package to you at the
                      earliest possibility. In case, they are unable to reach
                      your provided address or at a suitable time, they will
                      contact you to resolve the issue.
                    </li>
                  </ol>

                  <h4 className="fw-semibold mt-3">How are items packaged?</h4>
                  <p>
                    We package our products in cardboard boxes with your invoice
                    wrapped with along with it. Fragile items like bottles are
                    safely secured with additional bubble wrap.
                  </p>

                  <h4 className="fw-semibold mt-3">
                    What are the delivery charges?
                  </h4>
                  <p>
                    <span className="fw-semibold">
                      Inside and outside Dhaka:
                    </span>{' '}
                    {shippingCost?.[0]?.value || 100} BDT for less than{' '}
                    {minShippingAmount?.[0]?.value || 1500} tk purchase. Free
                    delivery over {minShippingAmount?.[0]?.value || 1500} tk
                  </p>

                  <h4 className="fw-semibold mt-3">
                    What is the estimated delivery time?
                  </h4>
                  <p>
                    <span className="fw-semibold">
                      Inside Dhaka and Chittagong:
                    </span>{' '}
                    1-2 working days
                  </p>
                  <p>
                    <span className="fw-semibold">Outside Dhaka:</span> 4-5
                    working days
                  </p>
                  <p>
                    However, the delivery might be delayed based on political,
                    environmental, transportation, or any other unavoidable
                    issues which will be notified by our customer relationship
                    team.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
